import { css } from '@emotion/css';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    padding-top: 8px;
  `,
  categories: css`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 40px;
  `,
};

export default styles;
